import { render, staticRenderFns } from "./LocalGroups.vue?vue&type=template&id=4e7ddfb8&scoped=true&"
import script from "./LocalGroups.vue?vue&type=script&lang=ts&"
export * from "./LocalGroups.vue?vue&type=script&lang=ts&"
import style0 from "./LocalGroups.vue?vue&type=style&index=0&id=4e7ddfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ddfb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VIcon,VTextField})
